import React, { useState } from "react";

/**
 * Clean minimal accordion 
 * - CSS-based triangle icon (no iOS Safari substitution)
 * - Smooth rotation
 */

const Accordion = ({ title, children, defaultOpen = false }) => {
  const [open, setOpen] = useState(defaultOpen);

  return (
    <div style={{ width: "100%", marginBottom: "1rem" }}>
      {/* Header */}
      <div
        onClick={() => setOpen(!open)}
        style={{
          cursor: "pointer",
          padding: "0.75rem 0",
          fontWeight: 600,
          fontSize: "1.05rem",
          borderBottom: "1px solid #ddd",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <span>{title}</span>

        {/* TRUE CSS TRIANGLE (never replaced on iOS) */}
        <span
          style={{
            display: "inline-block",
            width: 0,
            height: 0,
            borderLeft: "6px solid transparent",
            borderRight: "6px solid transparent",
            borderTop: "8px solid #000",
            transform: open ? "rotate(0deg)" : "rotate(-90deg)",
            transition: "transform 0.2s ease",
          }}
        />
      </div>

      {/* Content */}
      {open && (
        <div
          style={{
            padding: "0.75rem 0",
            fontSize: "0.95rem",
            lineHeight: "1.45rem",
          }}
        >
          {children}
        </div>
      )}
    </div>
  );
};

export default Accordion;